import { render, staticRenderFns } from "./SettingsOrganisations.vue?vue&type=template&id=29417dc4&scoped=true"
import script from "./SettingsOrganisations.vue?vue&type=script&lang=js"
export * from "./SettingsOrganisations.vue?vue&type=script&lang=js"
import style0 from "./SettingsOrganisations.vue?vue&type=style&index=0&id=29417dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29417dc4",
  null
  
)

export default component.exports